import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import Header, { ScrollProgress } from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import Facilities from './components/Facilities';
import Routine from './components/Routine';
import { Gallery, Testimonials } from './components/Gallery';
import Admission from './components/Admission';
import Footer, { Contact } from './components/Footer';
import FloatingActions from './components/FloatingActions';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <About />
        <Programs />
        <Facilities />
        <Routine />
        <Gallery />
        <Testimonials />
        <Admission />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </ThemeProvider>
  );
}

export default App;
